import axios from "axios";

const axiosClient = axios.create({
  baseURL:
    window._env_?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL,
});

export default axiosClient;
